import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../lib/shared/validators";

export const validatorTag = v.object({
  name: v.string(),
  slug: v.string(),
  color: v.optional(v.string()),
  usageCount: v.number(),
  internalControl,
});

export const tags = defineTableWithInternalControl(validatorTag)
  .index("by_slug", ["slug"])
  .index("by_company_and_slug", ["internalControl.companyId", "slug"])
  .index("by_company_and_usage", ["internalControl.companyId", "usageCount"])
  .searchIndex("search_tags", {
    searchField: "name",
    filterFields: ["internalControl.companyId"],
  });

export const attachableEntityType = v.union(
  v.literal("work_orders"),
  v.literal("clients"),
  v.literal("invoices"),
  v.literal("products"),
  v.literal("services"),
  v.literal("quotations"),
  v.literal("sales"),
  v.literal("suppliers"),
  v.literal("equipment"),
  v.literal("personnel"),
  v.literal("document_records"),
  v.literal("attachments"),
);

export const validatorEntityTag = v.object({
  tagId: v.id("tags"),
  entityType: attachableEntityType,
  entityId: v.string(),
  internalControl,
});

export const entity_tags = defineTableWithInternalControl(validatorEntityTag)
  .index("by_tag", ["tagId"])
  .index("by_entity", ["entityType", "entityId"])
  .index("by_tag_and_entity", ["tagId", "entityType", "entityId"])
  .index("by_company_and_entity", [
    "internalControl.companyId",
    "entityType",
    "entityId",
  ])
  .index("by_company_and_tag", ["internalControl.companyId", "tagId"]);

export function slugify(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");
}
